import { NavLink } from 'react-router-dom';
import { FiHome, FiUsers, FiBook, FiGrid, FiCreditCard, FiPrinter, FiArrowLeft } from 'react-icons/fi';
import styles from './DashboardSidebar.module.css';

function AdminSidebar({ onNavigate }) {
  const links = [
    { to: '/admin', icon: <FiHome />, label: 'Overview', end: true },
    { to: '/admin/users', icon: <FiUsers />, label: 'Users' },
    { to: '/admin/menus', icon: <FiBook />, label: 'Menus' },
    { to: '/admin/seating-areas', icon: <FiGrid />, label: 'Seating Areas' },
    { to: '/admin/subscriptions', icon: <FiCreditCard />, label: 'Subscriptions' },
    { to: '/admin/printers', icon: <FiPrinter />, label: 'Printers' },
    { to: '/dashboard', icon: <FiArrowLeft />, label: 'Back to App' },
  ];

  return (
    <aside className={styles.sidebar}>
      <nav className={styles.nav}>
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            onClick={onNavigate}
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ''}`
            }
            end={link.end}
          >
            <span className={styles.icon}>{link.icon}</span>
            <span className={styles.label}>{link.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}

export default AdminSidebar;
